<div class="ds-table-container">
  <div class="ds-table-wrapper pb-2">
    <table
      class="ds-table"
      [ngClass]="['ds-table-' + size]"
      [class.ds-table--focusable]="focusable"
      [class.ds-table--multi-header]="secondHeaderRow.length > 0"
      mat-table
      [dataSource]="tableData"
      [trackBy]="tableTrackBy"
      [fixedLayout]="true"
      matSort
      [matSortActive]="initialSortActive"
      [matSortDirection]="initialSortDirection"
      [matSortDisableClear]="sortDisableClear"
      (matSortChange)="onSortChange($event)"
      (contentChanged)="onContentChanged()"
      [multiTemplateDataRows]="hasExpandRows"
    >
      <ng-container [matColumnDef]="EXPAND_TOGGLE_COLUMN" *ngIf="hasExpandRows">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="ds-expand-toggle-header"
          [attr.rowspan]="secondHeaderRow.length ? 2 : null"
        ></th>
        <td mat-cell *matCellDef="let row" class="ds-expand-toggle-cell">
          <ds-icon
            *ngIf="row.__hasExpandableContent"
            [icon]="row.__expandIcon"
            width="20px"
            height="20px"
            type="info"
            (click)="onRowClick(row, $event)"
          ></ds-icon>
        </td>
      </ng-container>

      <ng-container *ngFor="let col of columnList; trackBy: trackColumnName" [matColumnDef]="col.name">
        <th
          mat-header-cell
          *matHeaderCellDef
          [mat-sort-header]="col.sortable ? col.name : $any(null)"
          [disabled]="!col.sortable"
          [style.width]="col.width"
          [attr.rowspan]="col.headerRowspan > 1 ? col.headerRowspan : null"
          [attr.colspan]="col.headerColspan > 1 ? col.headerColspan : null"
        >
          <div class="d-flex w-100 th-content" [style.justify-content]="col.columnAlign">
            <ng-container *ngIf="col.dsHeader">
              <ng-container *ngTemplateOutlet="col.dsHeader"></ng-container>
            </ng-container>
          </div>
        </th>
        <td mat-cell *matCellDef="let row; let i = index">
          <div class="d-flex" [style.justify-content]="col.columnAlign">
            <ng-container *ngIf="col.dsCell">
              <ng-container
                *ngTemplateOutlet="col.dsCell; context: { $implicit: row, row: row, index: i }"
              ></ng-container>
            </ng-container>
          </div>
        </td>
      </ng-container>

      <ng-container *ngFor="let expand of expandList" [matColumnDef]="expand.name">
        <td mat-cell *matCellDef="let row; let i = index" [attr.colspan]="displayedColumns.length">
          <div class="d-flex" [style.justify-content]="expand.columnAlign">
            <ng-container *ngIf="expand.dsCell">
              <ng-container
                *ngTemplateOutlet="expand.dsCell; context: { $implicit: row, row: row, index: i }"
              ></ng-container>
            </ng-container>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="firstHeaderRow"></tr>
      <tr mat-header-row *matHeaderRowDef="secondHeaderRow" [class.d-none]="secondHeaderRow.length === 0"></tr>

      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns; when: isDataRow"
        [attr.tabindex]="focusable ? 0 : null"
        (click)="onRowClick(row)"
        (keydown.enter)="onFocusableActivate(row, $event)"
        (keydown.space)="onFocusableActivate(row, $event, true)"
        (keydown.arrowup)="onArrowNavigate($event, -1)"
        (keydown.arrowdown)="onArrowNavigate($event, 1)"
        [class.clickable]="row.__isClickable"
        [class.row-odd]="row.__isOdd && !row.highlight_type"
        [ngClass]="row.highlight_type ? 'row-' + row.highlight_type : null"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns; when: isNestedRow"
        class="nested-data-row"
        [attr.tabindex]="focusable ? 0 : null"
        (keydown.arrowup)="onArrowNavigate($event, -1)"
        (keydown.arrowdown)="onArrowNavigate($event, 1)"
        [class.row-odd]="row.__isOdd && !row.highlight_type"
        [ngClass]="row.highlight_type ? 'row-' + row.highlight_type : null"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: expandColumns; when: showExpandDetailRow"
        class="detail-row"
        [@expandRow]="row.__expandState"
      ></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell text-center p-3" [attr.colspan]="displayedColumns.length">{{ noDataLabel }}</td>
      </tr>
    </table>
  </div>
</div>

<div style="display: none">
  <ng-content></ng-content>
</div>
